export const secureRoutes = [
  '/about-you',
  '/review',
  '/bookings',
  '/edit-shop',
  '/edit-date',
  '/edit-partner',
  '/edit-address',
  '/edit-your-details',
  '/edit-question-answers',
];
